import axios from "axios";

const getAxiosInstance = () => {
  const getAxios = axios.create({
baseURL: "https://think-big.bilimbe.in/api/",
// baseURL:"https://bilimbe-product-management.onrender.com/api/"
  });
  return getAxios;
};
const useAxios = () => {
  const useAxiosData = getAxiosInstance();
  return useAxiosData;
};

export default useAxios;